import {
  FormFieldsByUniqueID,
  SimpleFormField,
} from 'components/form/formTypes'
import { GeckoToggleForm } from 'components/form/GeckoToggleForm'
import React from 'react'
import { SubmitHandler } from 'react-hook-form'

interface DetectionConfigurationFormProps {
  formFields: FormFieldsByUniqueID[]
  inEditMode: boolean
  onSubmit: SubmitHandler<SimpleFormField>
}

export const EditDetectionConfigurationForm = React.forwardRef<
  HTMLFormElement,
  DetectionConfigurationFormProps
>(({ formFields, inEditMode, onSubmit }, ref) => {
  return (
    <GeckoToggleForm
      formFieldsByUniqueID={formFields}
      inEditMode={inEditMode}
      onSubmit={onSubmit}
      ref={ref}
      numberOfColumns={1}
    />
  )
})

EditDetectionConfigurationForm.displayName = 'DetectionConfigurationForm'
